<template>
<div>
  <div class="wistia_embed wistia_async_nfsrrthd1x">
    &nbsp;
  </div>

  <span
    id="vid-embeds-percents"
    class="tbk-vid-embed"
  >
    <a
      id="twenty-pct"
      class="embedded_video"
      href="#wistia_cg12lhb8ww?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="forty-pct"
      class="embedded_video"
      href="#wistia_ze9k9xliq8?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="sixty-pct"
      class="embedded_video"
      href="#wistia_jmnkmxjngc?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </span>

  <span
    id="vid-embeds-years"
    class="tbk-vid-embed"
  >
    <a
      id="eighty-years"
      class="embedded_video"
      href="#wistia_cwfj2swwvp?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="ninety-years"
      class="embedded_video"
      href="#wistia_oh68lubyyl?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="hundred-years"
      class="embedded_video"
      href="#wistia_e87tdlbndp?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </span>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    // // Show the Call-to-Action after each video
    _wq.push({
      nfs: this.showPctSelect,
      cg1: this.showYearsSelect,
      ze9: this.showYearsSelect,
      jmn: this.showYearsSelect
    })

    if (this.tbk.isMobile()) {
      _wq.push({
        cg1: this.tbk.autoPlay,
        ze9: this.tbk.autoPlay,
        jmn: this.tbk.autoPlay,
        cwf: this.tbk.autoPlay,
        oh6: this.tbk.autoPlay,
        e87: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showPctSelect(video) {
      video.bind('end', () => {
        $('#vid-embeds-percents').css({ display: 'block' })
        this.tbk.hideMobileControls()
      })
    },

    showYearsSelect(video) {
      video.bind('end', () => {
        $('#vid-embeds-years').css({ display: 'block' })
        this.tbk.hideMobileControls()
      })
    }
  }
}
</script>

<style scoped lang="sass">
#vid-embeds-percents
  display: none
  background-image: url('~./bluezones-1_1_percents.jpg')
  background-size: cover
  position: absolute
  width: 100%
  height: 100%
#vid-embeds-years
  display: none
  background-image: url('~./bluezones-1_1_years.jpg')
  background-size: cover
  position: absolute
  width: 100%
  height: 100%
#vid-embeds-percents,
#vid-embeds-years
  a
    text-decoration: none
#twenty-pct, #eighty-years
  position: absolute
  top: calc(100% * (168 / 360))
  left: calc(100% * (25 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (165 / 360))
#forty-pct, #ninety-years
  position: absolute
  top: calc(100% * (168 / 360))
  left: calc(100% * (230 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (165 / 360))
#sixty-pct, #hundred-years
  position: absolute
  top: calc(100% * (168 / 360))
  left: calc(100% * (435 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (165 / 360))
</style>
